import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";

const initialState = {
  data: [],
  itemsCount: 0,
  pages: 0,
  isLoading: false,
  error: null,

  filter: {},
  page: 1,
  query: "",
};

export const getReelsReports = createAsyncThunk(
  "reelReports/getReelsReports",
  async ({ page, filter, user }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`/reels/reports/`, {
        params: {
          page,
          ...(user && { user }),
          ...filter,
        },
      });
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.response?.data?.message || "Failed to fetch reels"
      );
    }
  }
);

export const updateReportStatus = createAsyncThunk(
  "reelReports/updateReportStatus",
  async ({ id, adminComment, status }, thunkApi) => {
    try {
      const response = await axiosInstance.put(
        `/reels/reports/${id}`,
        {
          status: status,
          adminComment,
        }
      );
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.response?.data?.message || "Failed to fetch reels"
      );
    }
  }
);
const reelReportsSlice = createSlice({
  name: "reelReports",
  initialState,
  reducers: {
    resetState: () => initialState,
    clearError: (state) => {
      state.error = null;
    },
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setQuery: (state, action) => {
      state.query = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReelsReports.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = [];
        state.itemsCount = 0;
        state.pages = 0;
      })
      .addCase(getReelsReports.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data?.data || [];
        state.itemsCount = action.payload.data?.itemsCount || 0;
        state.pages = action.payload.data?.pages || 0;
      })
      .addCase(getReelsReports.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(updateReportStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateReportStatus.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateReportStatus.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const { clearError, setFilter, setPage, setQuery, resetState } =
  reelReportsSlice.actions;
export default reelReportsSlice.reducer;
